import React, { useEffect, useState } from "react";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
// import Helmet from "../component/common/Helmet";
import { Helmet } from "react-helmet";
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import ContactOne from "../elements/contact/ContactOne";
import ServiceList from "../elements/service/ServiceList";
import MobileFunctionList1Component from "../elements/works/MobileFunctionList1";
import { Label } from "reactstrap";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";
import Dialog from "./../component/common/Dialog";

import {
  Row,
  Col,
  Card,
  CardBody,
  Progress,
  UncontrolledTooltip,
  Button,
  Alert,
  FormGroup,
  Collapse,
} from "reactstrap";
import MobileFunctionList2Component from "../elements/works/MobileFunctionList2";
import { useTranslation } from "react-i18next";
import CookieConsent, { Cookies } from "react-cookie-consent";
import ImageCarousel from "../component/common/ImageCarousel";

const SlideList = [
  {
    textPosition: "text-left",
    description: "",
    buttonText: "Download App",
    buttonLink: process.env.REACT_APP_APP_STORE_URL,
  },
];
const EcoShiftLanding = () => {
  const { t, i18n } = useTranslation();

  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;
  const dandelion = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-ecoshift-eco-dandelion.webp`;
  const dandelion_mobile = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-ecoshift-eco-dandelion_mobile.webp`;

  const no_eco = `${process.env.PUBLIC_URL}/assets/images/gp_images/egocentric-ecocentric-ecosystem-model-shift-transition-nature-human.webp`;
  const eco = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecocentric-ecosystem-model-shift-transition-nature-human.webp`;
  const ecoshift_about1 = `${process.env.PUBLIC_URL}/assets/images/gp_images/coshift-ecoshift-eco-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-about-us.webp`;
  const gp_about_us = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-nature-on-the-board-with-seat-voice-voting-rights.webp`;
  const gp_belgium_map = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-mobile-app-search-next-step-in-belgium.webp`;
  const gp_download_mockup = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-mobile-app-logo-dandelion-features-functionalities.webp`;

  const appstore_logo = `${process.env.PUBLIC_URL}/assets/images/gp_images/gp_button_appstore.webp`;
  const playstore_logo = `${process.env.PUBLIC_URL}/assets/images/gp_images/gp_button_googleplay.webp`;

  // Store links come from .env; a badge is only shown once its URL is set
  const appStoreUrl = process.env.REACT_APP_APP_STORE_URL;
  const googlePlayUrl = process.env.REACT_APP_GOOGLE_PLAY_URL;
  const renderStoreBadges = (textColor = "#fff") =>
    appStoreUrl || googlePlayUrl ? (
      <div className="mt-3 d-flex flex-column align-items-center" style={{ width: "100%" }}>
        <div className="d-flex align-items-center justify-content-center flex-wrap gap-5">
          {appStoreUrl && (
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
              <img src={appstore_logo} height={56} alt={t("Download on the App Store")} />
            </a>
          )}
          {googlePlayUrl && (
            <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
              <img src={playstore_logo} height={56} alt={t("Get it on Google Play")} />
            </a>
          )}
        </div>
        <p
          className="mt-3 mb-0 text-center"
          style={{ color: textColor, fontSize: "0.95rem", lineHeight: 1.5, maxWidth: "36rem" }}
        >
          {t("Available in all European app stores. EcoShift covers Belgium for now: the certified eco-pros listed are Belgian.")}
        </p>
      </div>
    ) : null;

  const [shiftExpanded, setShiftExpanded] = useState(false);

  window.onload = function () {
    // Code runs after full page load
    console.log("Page fully loaded!");
    const purpose = document.getElementById("purpose");
    if (purpose) {
      purpose.style.opacity = 0;
    }
  };

  // listen in tab2
window.addEventListener('storage', (e) => {
  if (e.key === 'keepinform') {
    console.log('value now', e.newValue); // 'true'
    if (e.newValue != null) {
      localStorage.setItem('keepinform', 'true');  // string
    }
  }
  else if (e.key === 'cookieConsent') {
      console.log('value now', e.newValue); // 'true'

      if (e.newValue != null) {
        localStorage.setItem('cookieConsent', 'true'); // string
        setShowConsent(false);
      }
    }
});

  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // check if user already accepted
    const saved = localStorage.getItem("cookieConsent")// Cookies.get("cookieConsent");
    if (!saved) {
      setShowConsent(true);  // show banner
    }
  }, []);

  const acceptCookies = () => {
    //Cookies.set("cookieConsent", true);
    localStorage.setItem('cookieConsent', 'true'); // string
    setShowConsent(false);
  };


  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // trigger fade-in after mount
    const timer = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const info = queryParams.get("info");
  const lang = queryParams.get("lang");

  if (lang != null && lang != '') {
    let currentLang = localStorage.getItem("lang")
    if (currentLang != lang) {
      localStorage.setItem("lang", lang);
      // Optionally change locale here
      i18n.changeLanguage(lang);
    }
  }

  const [showDialog, setShowDialog] = useState(false);
  const [message, setMessage] = useState(false);

  // When component mounts or campaign changes
  useEffect(() => {
    if (info == "email") {
      //Cookies.set("keepinform", true);
      localStorage.setItem('keepinform', 'true');  // string
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string

      setShowConsent(false);  // hide banner
      setShowDialog(true);
      setMessage(
        t(
          "Your email address is now verified! Thanks.\n\nWe will keep you informed."
        )
      );
    } else if (info == "unsubscribe") {
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setShowDialog(true);
      setMessage(
        t(
          "You have successfully unsubscribed. You will no longer receive updates from us."
        )
      );
    } else if (info == "updated") {
      //Cookies.set("keepinform", true);
      localStorage.setItem('keepinform', 'true');  // string
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setShowDialog(true);
      setMessage(
        t(
          "Your contact information has been updated. \nWe will keep you informed."
        )
      );
    } else if (info == "removed") {
      setShowDialog(true);
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setMessage(
        t(
          "Your contact information has been removed from EcoShift system. You will no longer receive updates from us."
        )
      );
    } else if (info == "pro") {
      setShowDialog(true);
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setMessage(
        t(
          "Thank you for validating! Your EcoShift professional mode is now active on your app."
        )
      );
    } else if (info == "expired") {
      setShowDialog(true);
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setMessage(
        t(
          "Your session token has expired. Please try again."
        )
      );
    } else if (info == "error") {
      setShowDialog(true);
      //Cookies.set("cookieConsent", true);
      localStorage.setItem('cookieConsent', 'true'); // string
      setShowConsent(false);  // hide banner
      setMessage(
        t(
          "An error occurred. Please contact us at contact@ecoshift.eco. Thank you."
        )
      );
    }
  }, [info]);

  /*
  window.addEventListener("scroll", function () {
    const purpose = document.getElementById("purpose");
    var value = window.scrollY;
    //if (value > 100) {
    purpose.style.opacity = value / 100;
    //} else {
    //  purpose.style.opacity = 0;
    //}
  });
  */

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>EcoShift</title>
        <meta
          name="description"
          content="EcoShift ⁕ the digital platform for your eco-positive consumption!"
        />
        <meta
          name="keywords"
          content="ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible"
        />
        <meta property="og:title" content="eco shift" />
        <meta
          property="og:description"
          content="EcoShift ⁕ the digital platform for your eco-positive consumption!"
        />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://ecoshift.eco/" />
      </Helmet>

      <HeaderThree homeLink="#" logo="symbol-dark" color="color-black" />

      {/* Start Slider Area   */}
      <div className="">
        <div
          id="home"
          className="bg_home"
          style={
            isMobile
              ? { height: "820px" }
              : {
                  backgroundImage: `url(${dandelion}), linear-gradient(to right, #1466cc, #fff)`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "top right",
                }
          }
        >
          <div className="slider-wrapper">
            {/* Start Single Slide */}
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="d-flex align-items-center justify-content-center">
              {isMobile ? (
                <div className="container">
                  <table
                    style={{
                      border: "none",
                      borderCollapse: "collapse",
                      marginTop: "-50px",
                    }}
                  >
                    <tr>
                      
                      <td
                        style={{
                          width: "50%",
                          border: "none",
                          borderCollapse: "collapse",
                        }}
                      >
                        <img
                          id="logo"
                          className=""
                          src={icon}
                          width="160px"
                          style={{ transform: 'translateX(40px)' }}
                          alt="ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive"
                        />
                      </td>
                      <td
                        style={{
                          width: "50%",
                          border: "none",
                          borderCollapse: "collapse",
                        }}
                      >
                        <img
                          id="dandelion"
                          className=""
                          src={dandelion_mobile}
                          style={{ transform: 'translateX(20px)' }}
                          alt="ecoshift-ecoshift-eco-dandelion"
                        />
                      </td>
                    </tr>
                  </table>

                  <div className="row" style={{ marginBottom: "-50px" }}>
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <div className="align-vertical align-items-center">
                        <p
                          id="purpose"
                          className="content-title"
                          style={{
                            color: "#fff",
                            opacity: visible ? 1 : 0,
                            transition: "opacity 0.5s ease-in-out",
                          }}
                        >
                          {t("Slogan")}
                        </p>
                        {renderStoreBadges()}
                        <br />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <ImageCarousel />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="align-vertical align-items-center">
                        <img
                          id="logo"
                          className=""
                          height={256}
                          src={icon}
                          alt="ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive"
                        />
                        <p
                          id="purpose"
                          className="content-title23 mt-4"
                          style={{
                            color: "#fff",
                            opacity: visible ? 1 : 0,
                            transition: "opacity 0.5s ease-in-out",
                            lineHeight: "1.5",
                          }}
                        >
                          {t("Slogan")}
                        </p>
                        {renderStoreBadges()}
                        <br />
                      </div>
                    </div>
                    <div className="col-lg-6"></div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <ImageCarousel />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* End Single Slide */}
          </div>
        </div>
      </div>
      {/* End Slider Area   */}

      {/* Why EcoShift Area */}
      <Card id="why-ecoshift" style={{ backgroundColor: "#fff" }}>
        <CardBody>
          <div className="service-area creative-service-wrapper">
            <div className={isMobile ? "" : "container"}>
              <br />
              <br />
              <div className="row">
                <div className="flex justify-content-center col-lg-12 align-items-center">
                  <div className="text-center mt-3">
                    <p className="section-title">{t("Why EcoShift")}</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 mb-3">
                <Row>
                  <Col className={isMobile ? "col-12" : "col-4"}>
                    <br />
                    <p className="section-title-24 text-color-black ml-1">
                      {t("Our Starting Point")}
                    </p>
                    <div style={{height: '10px'}}/>
                    <p className="text-blod-description text-left-important">
                      {t("It all started with a simple question:").replaceAll("\n", isMobile ? " " : "\n")}
                    </p>
                    <p className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2">
                      {t(
                        "What actions can I take to improve my consumption’s impact?"
                      )}
                    </p>
                    <p className="text-blod-description text-left-important mt-2">
                      {t(
                        "We searched for simple ways to connect with eco-friendly professionals in our area. Inspired by the desire to make a positive change, we realised we needed a practical tool to help us act consciously, without feeling overwhelmed or discouraged."
                      )}
                    </p>
                  </Col>

                  <Col className={isMobile ? "col-12" : "col-4"}>
                    <br />
                    <p className="section-title-24 text-color-black ml-1">
                      {t("The Situation")}
                    </p>
                    <div style={{height: '10px'}}/>
                    <p className="text-blod-description text-left-important mb-2">
                      {t(
                        "Today, we live in societies where individual interests often outweigh collective well-being. Living sustainably is not yet the norm."
                      )}
                    </p>

                    <p
                      className="text-blod-description text-left-important"
                      style={{ display: "inline", marginRight: "5px" }}
                    >
                      {t(
                        "The facts of climate change are clear, but taking action comes with genuine challenges."
                      )}
                    </p>
                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "Old habits die hard, fear can lead to inaction or avoidance, and eco-anxiety can be crippling."
                      )}
                    </p>

                    <p className="text-blod-description text-left-important mt-2 mb-2">
                      {t(
                        "We know our daily choices have consequences, and yet it’s easy to let ourselves believe that our actions are just a drop in the ocean."
                      )}
                    </p>

                    <p
                      className="text-blod-description text-left-important"
                      style={{ display: "inline", marginRight: "5px" }}
                    >
                      {t("Surveys confirm that")}
                    </p>
                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "price, accessibility, and trust remain the biggest obstacles "
                      )}
                    </p>

                    <p
                      className="text-blod-description text-left-important mt-2 mb-2"
                      style={{ display: "inline" }}
                    >
                      {t("to making more eco-friendly choices.")}
                    </p>
                  </Col>

                  <Col className={isMobile ? "col-12" : "col-4"}>
                    <br />
                    <p className="section-title-24 text-color-black ml-1">
                      {t("Our Solution")}
                    </p>

                    <div style={{height: '10px'}}/>
                    <p className="text-blod-description text-left-important mb-2"
                    style={{ display: "inline", marginRight: "5px" }}>
                      {t(
                        "That’s why EcoShift was created with a simple idea:"
                      )}
                    </p>

                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "making eco-conscious choices easier for everyone."
                      )}
                    </p>
                    <br/>
                    <p
                      className="text-blod-description text-left-important"
                      style={{ display: "inline", marginRight: "5px" }}
                    >
                      {t(
                        "Through a digital platform"
                      )}
                    </p>
                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "connecting people with verified eco-professionals,"
                      )}
                    </p>
                    
                    <p
                      className="text-blod-description text-left-important mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "EcoShift aims to reduce obstacles and invites users to support a thriving community of responsible businesses. Beyond supporting local economies, we believe this approach"
                      )}
                    </p>
  
                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        "contributes to the common good and cultivates a genuine sense of fulfillment."
                      )}
                    </p>

                    <p className="mt-2" />

                    <p
                      className="text-blod-description text-left-important"
                      style={{ display: "inline", marginRight: "5px" }}
                    >
                      {t(
                        "Every eco-conscious choice we make contributes to a systemic"
                      )}
                    </p>
                    <p
                      className="text-blod-description text-left-important text-color-ECOSHIFT font-bold mt-2"
                      style={{ display: "inline" }}
                    >
                      {t("shift from egocentric to ecocentric models*")}
                    </p>

                    <p
                      className="text-blod-description text-left-important mt-2 mb-2"
                      style={{ display: "inline" }}
                    >
                      {t(
                        ", where humans and nature thrive and benefit from each other."
                      )}
                    </p>
                  </Col>
                </Row>
                <br />
                <Row>
                  {window.innerWidth >= 768 ? (
                    <Col className="col-lg-1 col-md-1"></Col>
                  ) : (
                    ""
                  )}
                  <Col className="col-lg-11 col-md-11">
                    <div
                      className="accordion custom_item_full mb-4"
                      id="accordionExample"
                    >
                      <div
                        className="card"
                        style={{
                          borderWidth: "2px",
                          borderStyle: "solid",
                          borderColor: "#8a8a8a",
                        }}
                        key="shiftExpanded"
                        id="shiftExpanded"
                      >
                        <div className="card-header">
                          <h2 className="mb-0">
                            <button
                              className="btn btn-link btn-block text-left position-relative"
                              type="button"
                              onClick={() => {
                                setShiftExpanded(!shiftExpanded);
                              }}
                            >
                              <p className="text-left-important text-blod-description text-color-black text-center-important">
                                {t(
                                  "*Shift from egocentric to ecocentric models"
                                )}
                              </p>
                              <span
                                className={`chevron ${
                                  shiftExpanded ? "checked" : ""
                                }`}
                              ></span>
                            </button>
                          </h2>
                        </div>

                        <Collapse isOpen={shiftExpanded}>
                          <div className="row mb-3 ml-1 mr-1">
                            <div className="col-6">
                              <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                                <img
                                  src={no_eco}
                                  alt="egocentric-ecocentric-ecosystem-model-shift-transition-nature-human"
                                  width="250"
                                  className="mr-1"
                                />
                              </div>
                              <div className="justify-content-end ml-1 mt-1">
                                <div>
                                  <p className="text-blod-description-18 font-bold">
                                    {t(
                                      "Egocentric focuses on human-centered interests."
                                    )}
                                  </p>
                                  <p className="text-blod-description-18 mt-3">
                                    {t(
                                      "This perspective puts human needs and well-being first. In sustainability, it values nature mainly for its benefits to people, often prioritising growth and comfort over ecosystems. Actions are justified when they serve humanity, sometimes at the cost of other species or the environment."
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                                <img
                                  src={eco}
                                  alt="ecocentric-ecosystem-model-shift-transition-nature-human"
                                  width="250"
                                  className="mr-1"
                                />
                              </div>
                              <div className="justify-content-end ml-1 mt-1">
                                <div>
                                  <p className="text-blod-description-18 font-bold">
                                    {t(
                                      "Ecocentric places the health and integrity of the entire ecosystem at the core of ethical concern."
                                    )}
                                  </p>
                                  <p className="text-blod-description-18 mt-3">
                                    {t(
                                      "An ecocentric worldview values all life and ecosystems for their own sake, not just for human use. It prioritises balance, connection, and the flourishing of species and systems, even when that means limiting human exploitation."
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3 ml-1 mr-1 justify-content-center">
                            {t("Graphics inspired by GaiaVerso")}
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* End of Why EcoShift Area */}

      {/* The Platform Area */}
      <Card id="the-platform" style={{ backgroundColor: "#75b2ff" }}>
        <CardBody>
          <div className="service-area creative-service-wrapper">
            <div className={isMobile ? "" : "container"}>
              <br />
              <br />
              <div className="row">
                <div className="flex justify-content-center col-lg-12 align-items-center">
                  <div className="text-center mt-3">
                    <p className="section-title">{t("A platform to")}</p>
                  </div>
                </div>
              </div>
              <br />
              <div className="col-lg-12 mb-3">
                <ServiceList
                  item="4"
                  column="col-lg-4 col-md-4 col-sm-4 col-12 text-left"
                />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* The Platform Area  */}
      <Card id="" style={{ backgroundColor: "#75b2ff" }}>
        <CardBody>
          <div className="service-area creative-service-wrapper">
            <div className={isMobile ? "" : "container"}>
              <div className="row">
                <div className="flex justify-content-center col-lg-12 align-items-center">
                  <div className="text-center mt-3">
                    <p className="section-title">{t("Mission")}</p>
                  </div>
                </div>
              </div>
              <br />
              <div
                className="row creative-service align-items-center"
                style={{ backgroundColor: "white", paddingBottom: "30px" }}
              >
                <div className="col-lg-4">
                  <MobileFunctionList1Component
                    item="7"
                    column="col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                  />
                </div>
                <div className="col-lg-4">
                  <img
                    style={{
                      maxWidth: "850px",
                      objectFit: "cover",
                      height: "auto",
                      width: "100%",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    src={gp_download_mockup}
                    alt="ecoshift-mobile-app-logo-dandelion-features-functionalities"
                  />
                </div>
                <div className="col-lg-4">
                  <MobileFunctionList2Component
                    item="7"
                    column="col-lg-12 col-md-12 col-sm-12 col-12 text-left"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* End The Platform Area  */}

      {/* Start About us Area  */}
      <Card id="about-us" className="card_color--ugs ">
        <CardBody>
          <div className="service-area creative-service-wrapper card_color--ugs ">
            <div className={isMobile ? "" : "container"}>
              <br />
              <br />
              <div className="col-lg-12 section-title text-center mb_sm--0 d-flex-column-20">
                <p className="section-title text-color mt-3">{t("About us")}</p>
              </div>
              <br />

              <div className="row align-items-center">
                <div
                  className={
                    window.innerWidth >= 768
                      ? "col-lg-6 d-flex justify-content-end align-items-center"
                      : "col-lg-6 d-flex justify-content-center align-items-center mb-2"
                  }
                >
                  <img
                    src={ecoshift_about1}
                    alt="ecoshift.eco"
                    width="300"
                    className="mr-1"
                  />
                </div>

                <div className="col-lg-6">
                  <p className="section-title-left-26 text-color-ECOSHIFT ml-1">
                    {t("Who are we?")}
                  </p>

                  <div className="justify-content-left ml-1 mt-1">
                    <div>
                      <span
                        className="item-title-medium text-left-important mt-10 text-blod-description"
                        dangerouslySetInnerHTML={{
                          __html: t(
                            "At EcoShift, we are humans committed to the\n<b>common good</b> and united by a <b>shared vision</b>:\neveryone can make meaningful, human-sized changes,\nadapted to their own journey and capabilities, to\ncontribute to a more sustainable future for all."
                          ).replaceAll("\n", isMobile ? " " : "\n"),
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <br />
              <div className="row align-items-center">
                {window.innerWidth < 768 ? (
                  <div className="col-lg-6 d-flex justify-content-center align-items-center mb-2">
                    <img
                      src={gp_about_us}
                      alt="ecoshift-nature-on-the-board-with-seat-voice-voting-rights"
                      width="300"
                      className="ml-1"
                    />
                  </div>
                ) : (
                  ""
                )}

                <div className="col-lg-6 justify-content-end">
                  <p
                    className={
                      window.innerWidth >= 768
                        ? "section-title-right-26 text-color-ECOSHIFT ml-1"
                        : "section-title-left-26 text-color-ECOSHIFT ml-1"
                    }
                  >
                    {t("Nature on the Board")}
                  </p>

                  <div className="justify-content-end ml-1 mt-1">
                    <div>
                      <p
                        className={
                          window.innerWidth >= 768
                            ? "text-blod-description text-right-important"
                            : "text-blod-description text-left-important"
                        }
                      >
                        {t("On EcoShift’s Board of Management,")}
                      </p>
                      <p
                        className={
                          window.innerWidth >= 768
                            ? "text-blod-description text-right-important"
                            : "text-blod-description text-left-important"
                        }
                        dangerouslySetInnerHTML={{
                          __html: t(
                            "Nature has a <b>seat</b>, a <b>voice</b>, and <b>voting rights</b>."
                          ),
                        }}
                      ></p>
                      <p
                        className={
                          window.innerWidth >= 768
                            ? "text-blod-description text-right-important"
                            : "text-blod-description text-left-important"
                        }
                      >
                        {t("Learn more about Nature on the board ")}
                        <a
                          href={`${process.env.PUBLIC_URL}/nature-on-the-board`}
                          style={{
                            color: "#337DFF",
                            textDecoration: "underline",
                          }}
                        >
                          {t("here")}
                        </a>
                        !
                      </p>
                    </div>
                  </div>
                </div>

                {window.innerWidth >= 768 ? (
                  <div className="col-lg-6 d-flex justify-content-left align-items-center">
                    <img
                      src={gp_about_us}
                      alt="ecoshift-nature-on-the-board-with-seat-voice-voting-rights"
                      width="300"
                      className="ml-1"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>

              <br />
              <div className="row mt-4">
                <div className="col-12 d-flex justify-content-center align-items-center">
                  <div className="justify-content-center ml-1 mt-1">
                    <p className="section-title-26 text-color-ECOSHIFT ml-1">
                      {t("Our Values")}
                    </p>
                    <p className="text-blod-description ml-1 text-center-important">
                      {t("We live by and share seven essential values:")}
                    </p>
                    <br />
                  </div>
                </div>
              </div>

              {isMobile ? (
                  <ul style={{margin: 16, padding: 0}}>
                    <li>
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Committed to sustainability and biodiversity")}
                      </p>

                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t("Always acting with long-term impact in mind.")}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Caring about initiatives and best practices")}
                      </p>

                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Celebrating what works and encouraging improvements."
                            )}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK ">
                        {t("Supporting those who act")}
                      </p>

                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Uplifting individuals, groups, and communities who make a difference."
                            )}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Implementing solutions")}
                      </p>

                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t("Focusing on positive and practical change.")}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Grateful and humble")}
                      </p>

                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Recognising we contribute to a bigger movement and can’t do this alone."
                            )}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Real and transparent")}
                      </p>
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Saying what we do and doing what we say; open by default."
                            )}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mt-2">
                      <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK">
                        {t("Financially independent")}
                      </p>
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Free to act responsibly, driven by our values, not by outside interests (yes, that’s important!)."
                            )}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
              ) : (
                <div>
                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Committed to sustainability and biodiversity")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t("Always acting with long-term impact in mind.")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Caring about initiatives and best practices")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Celebrating what works and encouraging improvements."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Supporting those who act")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Uplifting individuals, groups, and communities who make a difference."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Implementing solutions")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t("Focusing on positive and practical change.")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Grateful and humble")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Recognising we contribute to a bigger movement and can’t do this alone."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Real and transparent")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Saying what we do and doing what we say; open by default."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 justify-content-end">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description font-bold text-color-ECOSHIFT-DARK text-right-important">
                            {t("Financially independent")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-left align-items-center">
                      <div className="justify-content-end ml-1 mt-1">
                        <div>
                          <p className="text-blod-description-18 text-left-important">
                            {t(
                              "Free to act responsibly, driven by our values, not by outside interests (yes, that’s important!)."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
      {/* End About us Area  */}

      {/* Start Next Area */}
      <br />
      <Card id="next" className="">
        <CardBody>
          <div className="slider-wrapper">
            <div className={isMobile ? "mt-3" : "container mt-3"}>
              <div className="row mt-4">
                <div className="col-lg-8 col-md-8">
                  <br />
                  <p className="section-title-left">{t("What’s next?")}</p>
                  <br />
                  {isMobile ? <div/> :
                  <div>
                  <br />
                  <br />
                  </div>
}
                  <p className="text-blod-description text-left-important">
                    {t(
                      "The app is live"
                    )}
                  </p>
                  <p className="text-blod-description text-left-important mt-3 mb-3">
                    {t(
                      "EcoShift is available on the App Store and Google Play. Download the app, find certified eco-pros around you, and have them scan your QR code to bring your loyalty card to life."
                    )}
                  </p>

                        {renderStoreBadges("#4a4a4a")}
                        
                        <br />
                </div>
                <div className="col-lg-4 col-md-4">
                  <div className="align-vertical align-items-center">
                    <img
                      style={{
                        maxWidth: "850px",
                        objectFit: "cover",
                        height: "auto",
                        width: "100%",
                      }}
                      src={gp_belgium_map}
                      alt="ecoshift-mobile-app-search-certified-eco-pros-belgium"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
          <br />
        </CardBody>
      </Card>
      {/* End Next Area */}

      {/* Start Contact Area */}
      <div id="keep-informed" className="">
        <div className="rn-contact-area pb--120 custom_back_ground">
          <ContactOne
            contactImages="/assets/images/about/about-13.jpg"
            contactTitle="Hire Me."
          />
        </div>
      </div>
      {/* End COntact Area */}

      <FooterTwo homeLink="#" logo="symbol-dark" color="color-black" />
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}

      <Dialog
        isOpen={showDialog}
        onClose={() => {
          window.location.href = `${process.env.PUBLIC_URL}/#home`;
        }}
        title=""
      >
        <div className="text-blod-description justify-content-center align-items-center ml-3 mr-3 mt-2 mb-2">
          <p className="text-blod-description text-center-important">
            {message}
          </p>
        </div>
      </Dialog>

      {/* GDPR Cookie Consent */}
      {showConsent && (
      <CookieConsent
        location="none" // disables default positioning
        buttonText={t("Got it!")}
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          background: "#fff",
          color: "#000",
          paddingLeft: window.innerWidth >= 768 ? "50px" : "10px",
          paddingRight: window.innerWidth >= 768 ? "50px" : "10px",
          borderRadius: "24px",
          boxShadow: "0 0 10px rgba(0,0,0,0.3)",
          zIndex: 9999,
          maxWidth: "90%",
          width: "auto",
          textAlign: "center",
          flexDirection: "column", // stack text + button vertically
          alignItems: "center", // center horizontally
          justifyContent: "center",
          textAlign: "center",
        }}
        contentStyle={{
          flex: "0 0 auto", // prevent stretching
          marginBottom: "15px",
        }}
        buttonWrapperClasses={
          window.innerWidth >= 768 ? "cookie-btn-top-right" : ""
        } // custom class
        buttonStyle={{
          background: "#337DFF",
          color: "#fff",
          border: "none",
          padding: "8px 20px",
          borderRadius: "24px",
          cursor: "pointer",
          marginTop: "15px",
        }}
        // declineButtonText="Decline"
        // enableDeclineButton
        // declineButtonStyle={{
        //   background: "#f44336",
        //   color: "#fff",
        //   border: "none",
        //   padding: "10px 30px",
        //   borderRadius: "24px",
        //   cursor: "pointer",
        //   marginTop: "15px",
        //   marginLeft: "10px",
        // }}
        expires={365}
        onAccept={acceptCookies}
        // onDecline={() => {
        //   console.log("Cookies declined");
        // }}
      >
        <p className="item-title-large">{t("Your privacy matters to us.")}</p>
        <p className="item-description-large mt-3">
          {t("This site runs on essential cookies only.")}
        </p>
        <p className="item-description-large">
          {t("No marketing, no analytics, no personal data collected.")}
        </p>
        <p className="item-description-large">{t("As simple as that!")}</p>
        <p className="item-description-large mt-3">
          {t("To find out more, see our ")}
          <a
            href={`${process.env.PUBLIC_URL}/privacy`}
            style={{ color: "#337DFF", textDecoration: "underline" }}
          >
            {t("Privacy Policy")}
          </a>
          .
        </p>
      </CookieConsent>
      )}

    </div>
  );
};

export default EcoShiftLanding;
